import React, { Component } from 'react';
import Col from 'react-bootstrap/Col'
import {Container, Jumbotron, Row} from "react-bootstrap";

import data from "../posters_data.json";
import history from "../history";

export default class PosterInfo extends Component {

    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.open = this.open.bind();
        this.update = this.update.bind();

        this.changeHeader = props.changeHeaderColors;

        this.state = {
            open: false,
            title: null,
            author: null,
            url: null,
            desc: null,
            tec: null,
            id: null,
            country: null
        }

        /*this.pathDev = 'https://eden.dei.uc.pt/~srebelo/dev/';*/ /*FIXME*/
    }

    close = () => {
        history.push("/2020/");
        this.ref.current.style.opacity = 0;
        this.changeHeader(false);
        this.ref.current.ontransitionend = () => {
            this.ref.current.style.display ="none";
        };
        document.getElementById('poster-full-info-container')

    }

    update = (id) => {
        this.setState({
            id: id,
            author: data[id].author,
            title: data[id].title,
            tec: data[id].tecnology_in,
            url: data[id].url,
            desc: data[id].description,
            country: data[id].country,
            moreInfo: data[id].links
        });
    }

    open = async (id) => {
        id = parseInt(id);
        await this.update(id);
        this.changeHeader(true);
        history.push(`/2020/exhibition/${(this.state.id+1)}`);
        this.ref.current.style.display = 'block';
        this.ref.current.style.opacity = 1;
    }

    render() {
        return (
        <Jumbotron ref={this.ref} id="poster-full-info-container" className="poster-full-info-container independent-scroll pb-5 pt-5" fluid>
            <Container fluid className="pt-4 pl-5 pr-5">
                <Row className="mobile-pt-2">
                    <Col>
                        <span onClick={this.close} className="close-wrapper">&times;</span>
                    </Col>
                    <Col sm={12} className="fullInfo-title">
                        <h3 className="mb">{this.state.title}</h3>
                        <p className="pb-5">{`${this.state.author} (${this.state.country})`}</p>
                    </Col>
                </Row>
                <Row className="mb-5">
                    <Col sm={12} md={6}>
                        <div className="mb-5">
                            <h4 className="upper">Poster's Description</h4>
                            <div dangerouslySetInnerHTML={{__html: this.state.desc}}/>
                        </div>
                        <div className="mb-5">
                            <h4 className="upper">Technologies used in/for</h4>
                            <div dangerouslySetInnerHTML={{__html: this.state.tec}}/>
                        </div>
                        <div className="mb-5 pb-3">
                            <p dangerouslySetInnerHTML={{__html: this.state.moreInfo}}/>
                        </div>
                    </Col>
                    <Col className="poster-full-img mb-5" sm={12} md={6}>
                        <Row>
                            <Col sm={0} md={1}/>
                            <Col sm={12} md={10}>
                                <img
                                    src={this.state.url}
                                    alt={`Poster ${this.state.title} designed by ${this.state.author}`}
                                />
                            </Col>
                            <Col sm={0} md={1}/>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Jumbotron>
        );
    }
}